import BScroll from "@better-scroll/core";
import { BScrollConstructor } from "@better-scroll/core/dist/types/BScroll";
import ObserveDOM from "@better-scroll/observe-dom";
import MouseWheel from "@better-scroll/mouse-wheel";
import PullDown from "@better-scroll/pull-down";
import Pullup from "@better-scroll/pull-up";
import { useState, useRef, useEffect } from "react";

export interface ScrollProps {
  wrapHeight: string;
  onPullup?: Function;
  onPulldown?: Function;
  children: React.ReactNode;
  prop: any;
}

/**
 * scroll component
 * @param wrapHeight wrap height
 * @param onPullup pulling up event
 * @param onPulldown pulling down event
 * @param children ReactNode
 */
const Scroll = ({
  wrapHeight,
  onPullup,
  onPulldown,
  children,
  prop,
}: ScrollProps) => {
  BScroll.use(ObserveDOM);
  BScroll.use(MouseWheel);
  BScroll.use(PullDown);
  BScroll.use(Pullup);

  // wrap ref
  const wrapRef = useRef<HTMLDivElement>(null);

  // scroll obj
  const [scrollObj, setscrollObj] = useState<BScrollConstructor>();

  // init better scroll
  const initBScroll = () => {
    setscrollObj(
      new BScroll(wrapRef.current as HTMLDivElement, {
        probetype: 3,
        click: true,
        observeDOM: true,
        mouseWheel: {
          speed: 20,
          invert: false,
          easeTime: 300,
        },
        scrollY: true,
        scrollbar: true,
        useTransition: true,
        pullDownRefresh: {
          threshold: 70,
          stop: 0,
        },
        pullUpLoad: {
          threshold: 50,
        },
      })
    );
  };

  // handle pulling down
  const pullingDown = async () => {
    onPulldown && (await onPulldown());
    setTimeout(() => {
      scrollObj?.finishPullDown();
      scrollObj?.refresh();
    }, 500);
  };

  //  handle pulling up
  const pullingUp = async () => {
    onPullup && (await onPullup());
    setTimeout(() => {
      scrollObj?.finishPullUp();
      scrollObj?.refresh();
    }, 500);
  };

  //  init better-scroll
  useEffect(() => {
    initBScroll();
    return () => {
      scrollObj?.destroy();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // init better-scroll event
  useEffect(() => {
    if (!prop.data || !prop.data.length) {
      scrollObj?.scrollTo(0, 0);
    }
    scrollObj?.refresh();
    scrollObj?.off("pullingDown");
    scrollObj?.on("pullingDown", pullingDown);
    scrollObj?.off("pullingUp");
    scrollObj?.on("pullingUp", pullingUp);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [prop]);
  return (
    <div
      className="scroll-warpper"
      ref={wrapRef}
      style={{ height: wrapHeight, overflow: "hidden" }}
    >
      <div className="scroll-content">{children}</div>
    </div>
  );
};

export default Scroll;
